import { Chip, IconButton, Link, Stack, Typography } from '@mui/material'
import React, { FunctionComponent, ReactElement } from 'react'
import { IconName } from '../../../../shared/interfaces/icon-picker.model'
import { IconPicker } from '../../display-elements-components/icon-picker'

export const ShallowFormDisplay: FunctionComponent<{
  name?: string,
  value?: string | number | boolean | React.ReactNode,
  bottomBorder?: boolean,
  topBorder?: boolean,
  sideBorders?: boolean,
  isTopRow?: boolean,
  isBottomRow?: boolean,
  tooltipElement?: ReactElement,
  icon?: IconName,
  iconButtonHandler?: () => void,
  editField?: string,
  small?: boolean,
  labelWidth?: string,
  chip?: { label: string, color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' },
  chips?: { label: string, color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' }[],
  href?: string,
}> = ({
  name,
  value,
  bottomBorder = false,
  topBorder = true,
  sideBorders = true,
  isTopRow = false,
  isBottomRow = false,
  tooltipElement,
  icon,
  iconButtonHandler,
  editField,
  small = false,
  labelWidth = '30%',
  chip,
  chips,
  href,
}) => {
    const allChips = [...(chips ?? []), ...(chip ? [chip] : [])]

    return (
      <Stack position='relative' flexDirection='row' justifyContent='start' alignItems='center'
        sx={{
          borderWidth: '1px',
          borderBottomStyle: bottomBorder || isBottomRow ? 'solid' : 'none',
          borderColor: 'lightGrey.main',
          borderLeftStyle: sideBorders ? 'solid' : 'none',
          borderRightStyle: sideBorders ? 'solid' : 'none',
          borderTopStyle: topBorder || isTopRow ? 'solid' : 'none',
          pt: 1, pb: 1, pl: 3,
          borderTopLeftRadius: isTopRow ? '10px' : 0,
          borderTopRightRadius: isTopRow ? '10px' : 0,
          borderBottomLeftRadius: isBottomRow ? '10px' : 0,
          borderBottomRightRadius: isBottomRow ? '10px' : 0,
          minHeight: small ? '24px' : '48px',
        }}>
        <Stack flexDirection={'row'} sx={{ width: labelWidth, minWidth: '120px' }}>
          <Typography variant='subtitle1' sx={{ color: 'text.primary', mr: 2 }}>{name}</Typography>
          {tooltipElement}
        </Stack>
        <Stack sx={{ width: `calc(100% - ${labelWidth})`, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', ml: 1 }}>
          <Stack flexDirection='row' alignItems='center' gap={1}>
            {href ? (
              <Link href={href} variant='body1' target='_blank' rel='noopener noreferrer'>{value}</Link>
            ) : (
              <Typography variant='body1' sx={{ color: 'text.secondary', whiteSpace: 'pre-wrap' }}>{value}</Typography>
            )}
            {allChips.length > 0 && (
              <Stack flexDirection='row' gap={1}>
                {allChips.map(c => (
                  <Chip key={c.label} label={c.label} size='small' color={c.color ?? 'default'} />
                ))}
              </Stack>
            )}
          </Stack>
          {icon && editField === '' && <IconButton onClick={iconButtonHandler} sx={{ mr: 2 }}>
            <IconPicker icon={icon} />
          </IconButton>}
        </Stack>
      </Stack>
    )
  }


